import { useTranslation } from 'react-i18next';

import { CreateProjectHeader } from '@/features/projects/create-project/components/layouts/create-project-header';
import { LoadingIndicator } from '@/shared/components/loading-indicator';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';

interface CreateProjectCreatingProjectProps {
  isLoading: boolean;
  error?: string;
}

export const CreateProjectCreatingProject = ({
  isLoading,
  error,
}: CreateProjectCreatingProjectProps) => {
  const { t } = useTranslation('project', {
    keyPrefix: 'CreateProjectSubmitPage',
  });

  return (
    <>
      <CreateProjectHeader />
      <Card variant="form" wrapWithStars>
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center gap-8">
            {isLoading && <LoadingIndicator className="size-16" />}
            {error && <p className="text-red-500">{error}</p>}
          </div>
        </CardContent>
      </Card>
    </>
  );
};
